import { useMutation, type UseMutationResult } from '@tanstack/react-query';
import type { ChangePasswordInput } from '@datazo/contracts';
import { apiFetch } from '@/shared/api/client';

/**
 * Cambio de contraseña del propio usuario autenticado.
 * El backend responde 204 (sin cuerpo) y no rota la sesión vigente.
 */
export function useChangePassword(): UseMutationResult<
  void,
  Error,
  ChangePasswordInput
> {
  return useMutation({
    mutationFn: (input: ChangePasswordInput) =>
      apiFetch<void>('/api/auth/change-password', {
        method: 'POST',
        body: input,
      }),
  });
}
